module.exports = __webpack_public_path__ + "img/singImg.9998baa4.png";